module.exports = __webpack_public_path__ + "static/media/6.740fe06.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/test/6.wav
// module id = beNQ
// module chunks = 0